import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import i18n from './i18n/reducers/i18n';
import setup from './setup/reducers';

export default combineReducers({
  routing: routerReducer,
  i18n,
  setup
});
